import { useSelector, useDispatch } from 'react-redux';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Check } from '@mui/icons-material';
import { capitalize } from 'lodash-es';
import { sendCropToYieldClean } from '../../lib/api';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { actions } from '../../store/dux/yield-dux';
import { usePermissions } from '../../hooks/use-permissions';
import { useContext } from './context.jsx';

export default function YieldEditCrop(props) {
  const { crop, coverage, aaid, status, fieldName } = props;
  const permissions = usePermissions();
  const growerId = useSelector(growerSelectors.selectedId) || '';
  const dispatch = useDispatch();
  const allowedToClean = permissions.includes('CLEAN_YIELD') || coverage >= 85;
  const isActionable = status !== 'Approved' && status !== 'Processing';
  const { year } = useContext();

  async function cleanCrop() {
    await sendCropToYieldClean(growerId, year, [{ aaid, crop, fieldName }]);
    dispatch(actions.loadYieldData(growerId, year));
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} p={1}>
      {capitalize(crop) || 'Unknown'} ({coverage}%){' '}
      {isActionable && (
        <>
          {allowedToClean ? (
            <Tooltip title="Clean Crop">
              <IconButton onClick={cleanCrop} data-testid={'clean-crop'}>
                <Check />
              </IconButton>
            </Tooltip>
          ) : null}
        </>
      )}
    </Box>
  );
}
